import { Skeleton, styled } from '@mui/material';

const StyledTrainerSelectSkeletonText = styled(Skeleton)(() => ({
  fontSize: '1rem',
  width: '50%'
}));

export default StyledTrainerSelectSkeletonText;
